import { HTTPClient } from '../utils/request'

export default {
  offersPerClient: ({ query }) => HTTPClient.get(`/dashboard/offers${query}`), // endpoint para filtrar as ofertas por cliente
  offerWeight: ({ query }) => HTTPClient.get(`/dashboard/offerWeight${query}`), // endpoint para filtrar as ofertas por cliente em tonelagem
  offersPerRegional: ({ query }) =>
    HTTPClient.get(`/dashboard/offerRegional${query}`), // endpoint para filtrar as ofertas por cliente
  offersRegionalWeight: ({ query }) =>
    HTTPClient.get(`/dashboard/offerRegionalWeight${query}`), // endpoint para filtrar as ofertas por cliente em tonelagem
  newDrivers: ({ query }) => HTTPClient.get(`/dashboard/driversNew${query}`), // endpoint para filtrar os novos drivers
  captation: ({ query }) => HTTPClient.get(`/dashboard/drivers${query}`), // endpoint para filtrar os drivers captados
  interestedDrivers: ({ query }) =>
    HTTPClient.get(`/dashboard/driversInterested${query}`), // endpoint para filtrar as ofertas por cliente
  countVehiclesByType: ({ query }) =>
    HTTPClient.get(`/dashboard/countVehiclesByType${query}`), // endpoint para filtrar os tipos de veículos
  countOffersByType: ({ query }) =>
    HTTPClient.get(`/dashboard/countOffersByType${query}`), // endpoint para total de ofertas pelo tipo de veículos
  vehicleAverageAge: ({ query }) =>
    HTTPClient.get(`/dashboard/vehicleAverageAge${query}`) // endpoint para trazer a idade média dos veículos
}
